import React, { PureComponent } from 'react';
import LoginPage from '../../../presenters/LoginPage/LoginPage';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import actions from '../../../../actions';
import { withRouter } from 'react-router-dom';
import { injectIntl } from 'react-intl';
import * as api from '../../../../services/api';
import { getRegion, setRegion } from '../../../../utils/session-util';
import { regions } from '../../../../constants/region';

class Login extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      isRegionSelectionEnabled: false
    };
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  async componentDidMount() {
    const isRegionSelectionEnabled =
      await api.applicationConfigurations.getRegionSelection();
    const currentRegion = getRegion();

    // if a region is disabled, and we have a prior region which is not US, change back to US as default
    if (!isRegionSelectionEnabled.data) {
      if (!currentRegion || currentRegion !== regions.USA)
        setRegion(regions.USA);
    }

    this.setState({
      isRegionSelectionEnabled: isRegionSelectionEnabled.data
    });
  }

  handleSubmit(event) {
    event.preventDefault();
    const username = event.target.username.value;
    const password = event.target.password.value;

    this.props.actions.authenticate(username, password);
  }

  render() {
    return (
      <LoginPage
        isRegionSelectionEnabled={this.state.isRegionSelectionEnabled}
        errorMessage={
          this.props.appStore.authenticationErrorMessage
            ? this.props.intl.formatMessage({
                id: this.props.appStore.authenticationErrorMessage
              })
            : null
        }
        handleSubmit={this.handleSubmit}
      />
    );
  }
}

const mapStateToProps = (state) => ({
  appStore: state.get('app').toJS()
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(actions, dispatch)
});

export default injectIntl(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(Login))
);
